import { render, staticRenderFns } from "./printers.vue?vue&type=template&id=0fb30cf6"
import script from "./printers.vue?vue&type=script&lang=js"
export * from "./printers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports